export default __webpack_public_path__ + "static/media/news4.29fa374a.jpg";